import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "messages", "form", "submit"];
  static values = { conversationId: String };

  connect() {
    this.scrollToBottom();
    // Auto-scroll when Turbo broadcasts a new assistant message into the
    // thread (the response arrives out-of-band via CaptainTandemChatJob).
    this.observer = new MutationObserver(() => this.scrollToBottom());
    this.observer.observe(this.messagesTarget, { childList: true });
  }

  disconnect() {
    this.observer?.disconnect();
  }

  submitOnEnter(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      this.formTarget.requestSubmit();
    }
  }

  showTyping() {
    if (this.hasSubmitTarget) this.submitTarget.disabled = true;
    const indicator = document.getElementById(`typing_indicator_${this.conversationIdValue}`);
    if (indicator) {
      indicator.innerHTML = `
        <div class="flex justify-start mb-3">
          <div class="flex items-center gap-1 px-4 py-3 rounded-2xl rounded-bl-sm bg-gray-100">
            <span class="w-2 h-2 rounded-full bg-gray-400 animate-bounce delay-bounce-300"></span>
            <span class="w-2 h-2 rounded-full bg-gray-400 animate-bounce delay-bounce-150"></span>
            <span class="w-2 h-2 rounded-full bg-gray-400 animate-bounce"></span>
          </div>
        </div>`;
      indicator.scrollIntoView({ block: "end", behavior: "smooth" });
    }
  }

  afterSubmit() {
    if (this.hasSubmitTarget) this.submitTarget.disabled = false;
    this.inputTarget.value = "";
    this.scrollToBottom();
  }

  scrollToBottom() {
    this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight;
  }
}
